export default "__VITE_ASSET__Blb8IrdJ__"